/**
 * Per-device-type manufacturer lists for the inspection wizard.
 *
 * Kept separate from inspectionSchema.ts so adding/removing a brand only
 * touches this file. Edits here require a frontend rebuild + deploy. If the
 * list starts changing frequently or per-shop, promote to a Dataverse
 * table or blob-config (see plans/check-in-device-detail.md follow-ups).
 *
 * Convention: lists are sorted alphabetically (case-insensitive) with
 * "Other" / "Custom" always at the end so the sentinel never gets buried.
 */

/**
 * Laptop manufacturers — used as Autocomplete suggestions on the laptop
 * inspection. Staff can still type any value not in the list (Autocomplete
 * is freeSolo) but they'll get the dropdown for the common cases.
 */
export const LAPTOP_MFR_SUGGESTIONS = [
  'Acer',
  'Apple',
  'Asus',
  'Dell',
  'Dynabook',
  'Framework',
  'Gigabyte',
  'HP',
  'Huawei',
  'Intel',
  'Lenovo',
  'Medion',
  'Microsoft',
  'MSI',
  'Razer',
  'Samsung',
  'Toshiba',
  'Other',
];

/**
 * Desktop manufacturers — fixed dropdown (no free text). "Custom" is the
 * catch-all for shop-built / unbranded boxes and is always last.
 */
export const DESKTOP_MFR_OPTIONS = [
  'Acer',
  'Asus',
  'Dell',
  'HP',
  'Lenovo',
  'MSI',
  'Custom',
];

/**
 * All-in-One manufacturers — fixed dropdown. AIOs are always OEM (there's
 * no "Custom" AIO to build), so no catch-all sentinel.
 */
export const AIO_MFR_OPTIONS = [
  'Acer',
  'Apple',
  'Asus',
  'Dell',
  'HP',
  'Lenovo',
  'MSI',
];

/**
 * Phone manufacturers — Autocomplete suggestions (freeSolo) like laptops,
 * since the brand space is large. "Other" sentinel last.
 */
export const PHONE_MFR_SUGGESTIONS = [
  'Apple',
  'Google',
  'Huawei',
  'Motorola',
  'Nokia',
  'OnePlus',
  'Oppo',
  'Samsung',
  'Sony',
  'Xiaomi',
  'Other',
];

/**
 * Tablet manufacturers — Autocomplete suggestions (freeSolo). "Other" last.
 */
export const TABLET_MFR_SUGGESTIONS = [
  'Amazon',
  'Apple',
  'Huawei',
  'Lenovo',
  'Microsoft',
  'Samsung',
  'Other',
];

/**
 * Hard drive manufacturers — fixed dropdown. "Other" is the catch-all for
 * unlabelled / unknown drives and is always last.
 */
export const HARD_DRIVE_MFR_OPTIONS = [
  'Crucial',
  'HGST',
  'SanDisk',
  'Samsung',
  'Seagate',
  'Toshiba',
  'Western Digital',
  'Other',
];

/**
 * USB flash drive manufacturers — fixed dropdown. "Other" last.
 */
export const USB_FLASH_DRIVE_MFR_OPTIONS = [
  'Kingston',
  'Lexar',
  'PNY',
  'SanDisk',
  'Samsung',
  'Sony',
  'Verbatim',
  'Other',
];

/**
 * Games console manufacturers — fixed dropdown. "Other" last.
 */
export const CONSOLE_MFR_OPTIONS = [
  'Microsoft',
  'Nintendo',
  'Sony',
  'Valve',
  'Other',
];
